export enum IncidentNibrsViolationType {
    DrugNarcotics = '35A',
    VehicleTheft = '240',
    
}